import React from "react";
import GooeyText from "./GooeyText";

const ROTATIONS = [
  "everything",
  "stocks",
  "crypto",
  "real estate",
  "gold",
  "bonds",
];

const AnimatedHeroTitle = () => (
  <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold tracking-[-0.02em] leading-[1.1] mb-6">
    <span className="block">
      <span className="bg-clip-text text-transparent bg-gradient-to-r from-emerald-400 via-sky-400 to-purple-500">
        A board of AI specialists
      </span>{" "}
      for
    </span>
    <span className="block">
      <GooeyText
        texts={ROTATIONS}
        morphTime={1}
        cooldownTime={0.4}
        textClassName="font-bold bg-clip-text text-transparent bg-gradient-to-r from-emerald-400 via-sky-400 to-purple-500"
      />
    </span>
  </h1>
);

export default AnimatedHeroTitle;
